import React from 'react';

/**
 * Incidents Help Content
 */
const IncidentsHelp: React.FC = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Incident Management
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          The Incidents page helps you track, manage, and resolve issues affecting your AI agents. From detection through resolution, maintain visibility into operational problems.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Incident Lifecycle
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Open</span>: New incident requiring attention</p>
          <p>&#8226; <span className="font-medium">Acknowledged</span>: Someone is investigating</p>
          <p>&#8226; <span className="font-medium">In Progress</span>: Actively being resolved</p>
          <p>&#8226; <span className="font-medium">Resolved</span>: Issue has been fixed</p>
          <p>&#8226; <span className="font-medium">Closed</span>: Incident review complete</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Severity Classification
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium text-red-600 dark:text-red-400">Critical (P1)</span>: Complete service outage</p>
          <p>&#8226; <span className="font-medium text-orange-600 dark:text-orange-400">High (P2)</span>: Major functionality impacted</p>
          <p>&#8226; <span className="font-medium text-yellow-600 dark:text-yellow-400">Medium (P3)</span>: Partial degradation</p>
          <p>&#8226; <span className="font-medium text-blue-600 dark:text-blue-400">Low (P4)</span>: Minor issues</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Key Metrics
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">MTTR</span>: Mean Time To Resolution</p>
          <p>&#8226; <span className="font-medium">MTTA</span>: Mean Time To Acknowledge</p>
          <p>&#8226; <span className="font-medium">Open Count</span>: Active incidents</p>
          <p>&#8226; <span className="font-medium">Resolution Rate</span>: Incidents resolved within SLA</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Managing Incidents
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          From the incident detail view you can:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; Update status and severity</p>
          <p>&#8226; Assign team members</p>
          <p>&#8226; Add timeline notes</p>
          <p>&#8226; Link related runs and traces</p>
          <p>&#8226; Document resolution steps</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Auto-Detection
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          Incidents can be created automatically when error rates exceed thresholds or when critical safety violations occur. Configure alert rules to customize detection.
        </p>
      </div>

    </>
  );
};

export default IncidentsHelp;
